import React from "react";

function ErrorPage() {
  return <div className="m-8 text-lg font-bold">ERROR! PAGE NOT FOUND</div>;
}

export default ErrorPage;
